<div>
  <app-tool-bar [title]="'Batch Configuration'" [iconName]="'pi-calendar'" [isAdd]="true"
    (handleAdd)="handleAddBatch()"></app-tool-bar>
</div>
<div class="p-4 overflow-auto h-[85vh]">
  <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
    (onLazyLoad)="loadData($event)" [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined"
    [loading]="loading">

    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 5rem">S.No</th>
        <th *ngFor="let col of columns" [pSortableColumn]="col.sortable ? col.field : ''">
          {{ col.header }}
          <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        <td>
          <div style="margin-left: 5px;">
            {{ rowIndex + 1 }}
          </div>
        </td>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.type">

            <ng-container *ngSwitchCase="'academic_year'">
              {{ rowData?.academic_year?.year_name || 'N/A' }}
            </ng-container>

            <ng-container *ngSwitchCase="'course'">
              {{ rowData?.course?.name || 'N/A' }}
            </ng-container>

            <ng-container *ngSwitchCase="'user'">
              {{ getFullName(rowData.user) || 'N/A' }}
            </ng-container>

            <ng-container *ngSwitchCase="'date'">
              {{ rowData[col.field] | date: 'longDate' }}
            </ng-container>

            <ng-container *ngSwitchCase="'actions'">
              <div *ngIf="!loading" (click)="setBatchData(rowData)">
                <p-menu [tabindex]="undefined" #menu [model]="batchActionItems" [popup]="true" appendTo="body">
                </p-menu>
                <button pButton type="button" (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"
                                    class="p-button-rounded p-button-text"></button>
              </div>
            </ng-container>

            <!-- Default -->
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>

          </ng-container>
        </td>
      </tr>
    </ng-template>

    <!-- Loading -->
    <ng-template pTemplate="loading">
      <tr>
        <td [attr.colspan]="columns.length + 1" class="text-center">
          <p-progressSpinner></p-progressSpinner>
        </td>
      </tr>
    </ng-template>

    <!-- Empty message -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length + 1" class="no-data">
          <p>No records found</p>
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>


<p-dialog [modal]="true" *ngIf="isAddBatch" [(visible)]="isAddBatch"
  [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }" [draggable]="false"
  [resizable]="false">

  <app-create-batch 
  [allCourses]="allCourses"
  [allAcademicYears]="allAcademicYears"
  [allUsers]="allUsers"
  [type]="'Create'"
  (closeDialog)="isAddBatch = false" (reload)="reloadData()"></app-create-batch>

</p-dialog>


<p-dialog [modal]="true" *ngIf="isEditBatch" [(visible)]="isEditBatch"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" closable="false" [style]="{ width: '50vw' }" [draggable]="false"
  [resizable]="false">

  <app-create-batch
  [allCourses]="allCourses"
  [allAcademicYears]="allAcademicYears"
  [allUsers]="allUsers"
  [type]="'Update'" [batchData]="batchData"
  (closeDialog)="isEditBatch = false" (reload)="reloadData()"></app-create-batch>

</p-dialog>

<p-dialog [modal]="true" *ngIf="isDeleteBatch" [(visible)]="isDeleteBatch"
  [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }" closable="false" [style]="{ width: '30vw' }" [draggable]="false"
  [resizable]="false">
  <app-delete-batch [batchData]="batchData" (closeDialog)="isDeleteBatch = false"
    (reload)="reloadData()"></app-delete-batch>
</p-dialog>